<template>
    <nav id="sidebar">

        <ul class="nav flex-column text-left">
            <li class="nav-item">
                <router-link class="nav-link text-white" to="/" exact active-class="active">
                    <font-awesome-icon icon="tachometer-alt"/>
                    Dashboard
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link text-white" to="/projects" active-class="active">
                    <font-awesome-icon icon="film"/>
                    Projects
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link text-white" to="/orders" active-class="active">
                    <font-awesome-icon icon="shopping-basket"/>
                    Orders
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link text-white" to="/customers" active-class="active">
                    <font-awesome-icon icon="user"/>
                    Customers
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link text-white" to="/licenses" active-class="active">
                    <font-awesome-icon icon="key"/>
                    Licenses
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link text-white" to="/distributors" active-class="active">
                    <font-awesome-icon icon="truck"/>
                    Distributors
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link text-white" to="/payments" active-class="active">
                    <font-awesome-icon icon="hand-holding-usd"/>
                    Payments
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link text-white" to="/settings" active-class="active">
                    <font-awesome-icon icon="sliders-h"/>
                    Settings
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link text-white" to="/integrations" active-class="active">
                    <font-awesome-icon icon="plug"/>
                    Integrations
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        name: "SidebarComponent"
    }
</script>

<style lang="scss" scoped>
    nav#sidebar {
        width: 250px;
        position: fixed;
        top: 48px;
        bottom: 0;
        left: 0;
        z-index: 100;
        background-color: #363839;

        li.nav-item a.nav-link {
            font-size: .85em;
            padding: .75rem 1rem;

            -webkit-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
            -moz-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
            -ms-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
            -o-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
            transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;

            &.active {
                background-color: #760000;
                color: var(--white);
            }

            &:not(.active):hover {
                background-color: rgba(0,0,0,.25);
            }
        }
    }


    nav#sidebar li.nav-item a.nav-link > svg {
        margin-right: 10px;
    }
</style>